


















import { computed, defineComponent, toRefs } from '@vue/composition-api'
import colorScheme from '../../colorScheme'

export interface CorrectTags {
  [key: string]: CorrectTagsList
}

export interface CorrectTagsList {
  color: string
  count: number
  title: string
  items: []
}

export default defineComponent({
  name: 'TagIndicators',
  props: {
    tags: {
      type: Array,
      required: true
    }
  },
  setup(props, { emit }) {
    const { tags } = toRefs(props)

    const correctTags = computed(() => {
      const correctTagsList = tags.value.reduce(
        (current: CorrectTags, elem: any) => {
          current[elem.color] = {
            color: elem.color,
            count: 0,
            title: '',
            items: []
          }
          return current
        },
        {}
      )

      tags.value.reduce((current: any, element: any) => {
        current[element.color].count++
        current[element.color].title += element.title + ' & '
        current[element.color].items.push(element)

        return current
      }, correctTagsList)

      return correctTagsList
    })

    function handleBadgeClick(event: any, tag: any) {
      if (tag.count === 1) {
        emit('show-tag', { event, tag })
      }
    }

    return { correctTags, colorScheme, handleBadgeClick }
  }
})
